import i18n from '@/i18n'

export const SIDE_NAV = 'SIDE_NAV'
export const SIDE_NAV_FLOAT = 'SIDE_NAV_FLOAT'
export const TAB_NAV = 'TAB_NAV'
export const COM_LAT = 48.864716
export const COM_LNG = 2.349014
export const MA_WARRANTY_WATER_MOBILIER = 'maWarrantyWaterMobilier'

// damage images types
export const ENSEMBLE_IMAGE = 'inputImgEnsemble'
export const PRES_IMAGE = 'inputImgPres'
export const PHOTOS_OPTIONS = [
  {
    name: ENSEMBLE_IMAGE,
    literal: i18n.t('warrantySticky.damageCounters.ensembleImage')
  },
  {
    name: PRES_IMAGE,
    literal: i18n.t('warrantySticky.damageCounters.presImage')
  }
]

// furniture damages
export const WATER_MOBILIER_DAMAGES = 'WATER_MOBILIER_DAMAGES'
export const BIENS_IMMOBILIERS = 'BIENS_IMMOBILIERS'
export const PROPERTY_TYPE = 'propertyType'
export const ASSETS = 'ASSETS'

// input types
export const SELECT = 'select'
export const RADIO = 'radio'
export const IMG_RADIO = 'imgRadio'
export const TEXT_NUMBERS = 'textNumbers'

// input names
export const PIECE = 'PIECE'
export const DAMAGE_SURFACE = 'DAMAGE_SURFACE'
export const ROOM_SURFACE = 'ROOM_SURFACE'
export const VETUSTED = 'VETUSTED'

// user roles
export const AGENT_ROLE = 'AGENT'
export const ALLIANZ_FRANCE_ROLE = 'AllianzFrance_Selfcare' // Provisional de Selfcare Allianz Francia
export const ALLIANZ_FRANCE_ADD_INFO = 'AllianzFrance_Selfcare300123_temp' // Provisional de Selfcare Allianz Francia
export const METREUR_ROLE = 'METREUR'
export const ALLIANZ_ITALY_USER = 'AllianzIT_user'

// damage types
export const INTERIOR_PROPERTY = 'BIENS_IMMOBILIERS_INTERIEURS'

// bus events
export const UPDATE_PIECES_SURFACE = 'update:piecesSurface'
export const UPDATE_PIECES_IDS = 'update:piecesIds'

// Mix Compensation
export const MIX_KEY = 'MIX_KEY'
export const REGULAR_KEY = 'REGULAR_KEY'

// dates
export const DATE_FORMAT = 'YYYY-MM-DD'

// user validation types
export const SMS = 'SMS'
export const EMAIL = 'EMAIL'

// encryption masks
export const EMAIL_MASK = 'xxxxxxx'
